export function waarschuwing(activatie: number): string {
  if (activatie <= 0.30) {
    return 'lage-activatie';
  } else if (activatie <= 0.60) {
    return 'matige-activatie';
  } else {
    return 'hoge-activatie';
  }
}
